function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  opacity: ".6",
  fill: "#FFB200"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 5.408l6.275 10.842H3.725L10 5.408zm0-3.325L.833 17.916h18.333L10 2.083z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.833 13.75H9.166v1.666h1.667V13.75zM10.833 8.75H9.166v4.166h1.667V8.75z"
}))));